export enum LoaderType {
    PILL,
    SKELETON
}
